export default "__VITE_PUBLIC_ASSET__5977f3b1__"